<template>
  <div v-if="show" class="wechat-share-guide" @click="shareClose">
    <div class="share-alert">
      <div class="alert-tips" v-html="shareTips"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WxShare',
  props: {
    show: Boolean,
    shareTips: ''
  },
  methods: {
    shareClose (e) {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.wechat-share-guide {
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .75);
  .share-alert {
    position: absolute;
    top: 10px;
    right: 10px;
    border-radius: 6px;
    background: linear-gradient(180deg, rgba(0, 40, 108, 0) 0%, #00286c 100%), #ef2ac1;
    .alert-tips {
      line-height: 20px;
      padding: 16px;
      white-space: nowrap;
      font-size: $font-nm;
      font-weight: 900;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/WxShare.vue